
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Affordableemployeestranportaion() {



    const cardData =
    {
        keyword: 'Affordable Employee Transportation Pune',
        heading: 'etravo : Affordable Employee Transportation Pune',
        headingDescription: 'eTravo provides Affordable Employee Transportation in Pune, combining cost-efficiency with reliability to support businesses of all sizes. Whether you are managing transport for a startup, mid-sized enterprise, or large corporation, our scalable solutions include , AC buses, and tempo travellers tailored to your budget and scheduling needs. With GPS-enabled vehicles, trained drivers, and optimized routes, we ensure safe, punctual, and comfortable commutes for your workforce. eTravo’s affordable plans help reduce operational costs while improving employee satisfaction and retention across Pune’s business hubs.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



"services": [
  {
    "name": "Affordable Employee Transportation Pune",
    "description": "eTravo offers affordable employee transportation in Pune with high service reliability, GPS-tracked vehicles, and tailored cost-saving plans for daily office commutes and shift-based staff movements."
  },
  {
    "name": "Low-Cost Corporate Cab and Bus Pune",
    "description": "Our low-cost corporate cab and bus services in Pune are ideal for businesses seeking economic yet efficient solutions for employee transport, including AC buses and corporate cab models."
  },
  {
    "name": "Budget Staff Transport Pune",
    "description": "eTravo’s budget staff transport in Pune includes structured pickup and drop options, suitable for small and mid-sized companies needing reliable daily commute services on a fixed budget."
  },
  {
    "name": "Employee Pickup and Drop Services Pune",
    "description": "We provide flexible employee pickup and drop services in Pune with safe, air-conditioned vehicles and route-optimized planning for multiple shifts and working hours."
  },
  {
    "name": "Reliable Yet Affordable Staff Commute Pune",
    "description": "Get the best of both worlds—eTravo’s reliable yet affordable staff commute services in Pune combine vehicle safety, route efficiency, and value-driven pricing for growing businesses."
  },
  {
    "name": "Monthly Rentals for Companies Pune",
    "description": "Our monthly rentals for companies in Pune simplify transport planning with predictable costs, consistent service quality, and easy scalability as team sizes grow."
  },
  {
    "name": "Custom Budget Mobility Plans Pune",
    "description": "eTravo offers custom budget mobility plans in Pune, helping businesses design personalized employee travel models that align with budget limits and operational demands."
  },
  {
    "name": "Economic Employee Bus Services Pune",
    "description": "Our economic employee bus services in Pune are designed for bulk staff movement with AC buses, professional drivers, and fixed-time scheduling for maximum cost-efficiency."
  },
  {
    "name": "Staff Car Rentals Pune",
    "description": "eTravo’s staff car rentals in Pune offer flexible options for small groups or individual commutes, ideal for last-mile connectivity and decentralized office locations."
  },
  {
    "name": "Corporate Shuttle Solutions Pune",
    "description": "Our corporate shuttle solutions in Pune provide and dedicated shuttles for employee transportation with route optimization, driver tracking, and fixed pricing."
  },
  {
    "name": "Cost-Effective Employee Transport Pune",
    "description": "eTravo delivers cost-effective employee transport in Pune without compromising comfort or safety, using data-backed planning and a modern vehicle fleet."
  },
  {
    "name": "Business Transport on Budget Pune",
    "description": "eTravo’s business transport on budget in Pune is built for startups and mid-scale companies, with scalable services for daily commute, events, and client visits."
  },
  {
    "name": "Value-for-Money Corporate Mobility Pune",
    "description": "Experience value-for-money corporate mobility in Pune through our competitive rates, prompt support, and multi-zone transport coverage using cabs and buses."
  },
  {
    "name": "End-to-End Affordable Commute Pune",
    "description": "eTravo ensures end-to-end affordable commute solutions in Pune, managing vehicle planning, dispatch, reporting, and real-time tracking in a single cost-efficient model."
  },
  {
    "name": "Employee Transit Management Pune",
    "description": "Our employee transit management in Pune helps HR teams streamline logistics, reduce absenteeism, and improve employee satisfaction with data-backed commute services."
  }
],
"tableData": [
  ["Affordable Employee Transportation Pune", "Low-Cost Corporate Cab and Bus Pune"],
  ["Budget Staff Transport Pune", "Employee Pickup and Drop Services Pune"],
  ["Reliable Yet Affordable Staff Commute Pune", "Monthly Rentals for Companies Pune"],
  ["Custom Budget Mobility Plans Pune", "Economic Employee Bus Services Pune"],
  ["Staff Car Rentals Pune", "Corporate Shuttle Solutions Pune"],
  ["Cost-Effective Employee Transport Pune", "Business Transport on Budget Pune"],
  ["Value-for-Money Corporate Mobility Pune", "End-to-End Affordable Commute Pune"],
  ["Employee Transit Management Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Affordable Employee Transportation in Pune",
        "WhyChoosedescription": "eTravo delivers cost-effective employee transport solutions across Pune without compromising on quality, safety, or punctuality—ideal for companies aiming to optimize budgets while ensuring workforce convenience."
    },
    {
        "WhyChooseheading": "Budget-Friendly Fleet Options",
        "WhyChoosedescription": "Our fleet includes hatchbacks, sedans, tempo travellers, and AC buses—allowing you to choose vehicles that match your team size and cost expectations while maintaining comfort and reliability."
    },
    {
        "WhyChooseheading": "Tailored Routes to Reduce Travel Costs",
        "WhyChoosedescription": "We design smart, efficient routes for pickup and drop services in Pune’s major areas like Hinjewadi, Kharadi, and Hadapsar—minimizing fuel usage and optimizing route planning for better cost savings."
    },
    {
        "WhyChooseheading": "Flexible Plans for All Business Sizes",
        "WhyChoosedescription": "Whether you're a small startup or a large enterprise, our scalable transport solutions in Pune are designed to meet your budget and employee headcount with flexible scheduling and vehicle options."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We provide upfront, all-inclusive pricing with GST-compliant invoicing and detailed monthly billing—giving your HR and finance teams full control over transport spending."
    },
    {
        "WhyChooseheading": "Safe, Clean, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Despite being budget-friendly, all our vehicles are regularly cleaned, serviced, and equipped with safety features like seat belts, GPS tracking, and first aid kits to ensure a secure commute."
    },
    {
        "WhyChooseheading": "24/7 Support and Real-Time Ride Tracking",
        "WhyChoosedescription": "Enjoy peace of mind with real-time vehicle tracking and round-the-clock customer support—helping you address route adjustments or transport concerns instantly."
    },
    {
        "WhyChooseheading": "Reliable Service Without Compromise",
        "WhyChoosedescription": "Our affordable solutions are built on punctuality, safety, and service quality—making eTravo a preferred choice for businesses across Pune looking for value-driven employee transportation."
    }
]


















    }

const faqData = [
    [
        {
            question: 'Does eTravo offer affordable employee transportation services in Pune?',
            answer: 'Yes, eTravo provides cost-effective employee transportation solutions in Pune without compromising on safety, punctuality, or service quality — ideal for businesses of all sizes.',
        },
        {
            question: 'How does eTravo ensure affordability in corporate transport?',
            answer: 'We use optimized routing, fleet models, and shift-based scheduling to reduce overhead and deliver budget-friendly transport solutions for daily employee commutes in Pune.',
        },
        {
            question: 'Are there flexible pricing plans for companies with varying team sizes?',
            answer: 'Absolutely. eTravo offers scalable pricing models based on fleet size, frequency, and route complexity — making it suitable for startups, mid-sized firms, and large enterprises alike.',
        },
        {
            question: 'What types of vehicles are used for affordable transport services?',
            answer: 'Our affordable transport fleet in Pune includes hatchbacks, sedans, tempo travellers, and AC buses (13–50 seaters), all maintained for efficiency, cleanliness, and comfort.',
        },
        {
            question: 'Is safety compromised in budget-friendly transportation plans?',
            answer: 'Not at all. Even in affordable plans, we maintain strict standards — including GPS tracking, driver verification, route compliance, and regular vehicle maintenance.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amol Desai',
        designation: 'Admin Officer, Protech Services, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We were looking for a reliable yet affordable transport partner in Pune — and eTravo delivered exactly that. Great service, transparent pricing, and on-time operations.”',
    },
    {
        name: 'Ms. Reema Pawar',
        designation: 'HR Executive, QuickNova Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has helped us manage employee transport within budget without cutting corners. Their support and service levels are top-notch, even in their affordable plans.”',
    },
];


















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Affordable Employee Transportation Pune",
  "image": "https://www.etravo.in/images/keyword/affordable-employee-transportation-pune.jpg",
  "description": "Affordable employee transportation services in Pune by eTravo. Budget-friendly corporate cab and bus rentals, staff pickup and drop, and customized low-cost commute plans for businesses.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/affordable-employee-transportation-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>Affordable Employee Transportation Pune | Budget Staff Commute & Cab Services | eTravo</title>
  <meta 
    name="description" 
    content="Get affordable employee transportation in Pune with eTravo. Budget cab and bus rentals, staff pickup and drop, monthly corporate commute solutions, and cost-effective mobility plans." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/110.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Affordableemployeestranportaion;